import { render } from "./SubAccountBlock.vue?vue&type=template&id=28e0ef65"
import script from "./SubAccountBlock.vue?vue&type=script&lang=js"
export * from "./SubAccountBlock.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\甘小星\\Desktop\\sakai-vue-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__